import React, { useState } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import * as Styles from './Slider.Styles';
import ArrowSVG from './Assets/Arrow-Forward-iOS.svg';

const Slider = ({ gatsbyImageData, slides, ...props }) => {
  const [current, setCurrent] = useState(0);
  let numberOfSlides = 0;
  if (gatsbyImageData === undefined) {
    return null;
  } else {
    if (gatsbyImageData.length <= 0) {
      return null;
    } else {
      numberOfSlides = gatsbyImageData.length;
    }
  }

  const nextSlide = () => {
    setCurrent(current === numberOfSlides - 1 ? 0 : current + 1);
  };
  const prevSlide = () => {
    setCurrent(current === 0 ? numberOfSlides - 1 : current - 1);
  };
  const changeSlide = (slideNumber) => {
    setCurrent(slideNumber);
  };

  return (
    <Styles.Container>
      <Styles.LeftArrow src={ArrowSVG} onClick={prevSlide} />
      <Styles.RightArrow src={ArrowSVG} onClick={nextSlide} />
      {gatsbyImageData.map(({ node }, index) => {
        return (
          <div
            className={index === current ? 'slide active' : 'slide'}
            key={index}>
            <GatsbyImage
              image={node.childImageSharp.gatsbyImageData}
              alt='image'
              objectFit='cover'
              className='image'
            />

            {/* {index === current && (
              <GatsbyImage
                image={node.childImageSharp.gatsbyImageData}
                className='image'
                alt='image'
                objectFit='cover'
              />
            )} */}
          </div>
        );
      })}
      {props.dots && (
        <Styles.Dot>
          {gatsbyImageData.map((slide, index) => {
            return (
              <Styles.DotItem
                key={index}
                className={current === index ? 'active' : null}
                onClick={() => changeSlide(index)}
              />
            );
          })}
        </Styles.Dot>
      )}
    </Styles.Container>
  );
};

export default Slider;
